import { RefreshCw } from "lucide-react";
import { useSyncExternalStore } from "react";
import { Button } from "@/components/ui/button";
import type { AppVersionCoordinator } from "@/lib/app-version-coordinator";

type ApplicationUpdateRecoveryProps = {
  coordinator: AppVersionCoordinator;
};

export function ApplicationUpdateRecovery({ coordinator }: ApplicationUpdateRecoveryProps) {
  const snapshot = useSyncExternalStore(
    coordinator.subscribe,
    coordinator.getSnapshot,
    coordinator.getSnapshot
  );

  if (!snapshot.manualRecoveryRequired) {
    return null;
  }

  return (
    <div
      role="alert"
      data-testid="application-update-recovery"
      className="fixed inset-x-4 bottom-4 z-[100] mx-auto flex max-w-2xl flex-col gap-3 rounded-lg border border-border bg-background p-4 shadow-xl sm:flex-row sm:items-center sm:justify-between"
    >
      <div>
        <p className="font-medium text-foreground">The application needs to reload</p>
        <p className="text-sm text-muted-foreground">
          Reload to continue with the current version. Your saved work will remain available.
        </p>
      </div>
      <Button type="button" className="shrink-0" onClick={() => coordinator.requestManualReload()}>
        <RefreshCw className="size-4" aria-hidden="true" />
        Reload application
      </Button>
    </div>
  );
}
